import styled from 'styled-components'
import {maxWidth} from 'core/theme'

export const Wrapper = styled.div`
  .secondary-header {
    max-width: 1440px;
  }

  .breadcrumbs-row {
    background-color: ${props => !props.whiteBreadcrumbs && props.background ? props.background : 'transparent'};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 32px 20px 136px;
    div {
      ul {
        list-style: none;
        margin-bottom: 0 !important;
        margin-top: 0 !important;
        padding-left: 0;
        position: relative;
        li {
          a {
            &:after{
              content: '/';
              display: inline-block;
              margin-left: 2px;
              margin-right: 2px;
              color: #007ACC;
            }
          }
        }
      }
    }
      
    .breadcrumbs__item {
      font-weight: normal;
      color: #999;
      display: inline-block;
    }
  
    .logged-in-breadcrumb {
      position: relative;
  
      &__unread-messages {
        top: 14px;
        left: 21px;
        position: absolute;
        width: 10px;
        height: 10px;
        -webkit-border-radius: 25px;
        -moz-border-radius: 25px;
        border-radius: 25px;
        background: red;
        z-index: 1;
        &--hide {
          display: none;
        }
      }
    }
    &__back-text {
      color: ${props => props.whiteBreadcrumbs ? '#FFF' : props.theme.colors.mercuryBlue};
      font-weight: 700;
      font-size: 13px;
      letter-spacing: 1px;
    }
    &__arrow {
      svg {
        fill:${props => props.whiteBreadcrumbs ? '#FFF' : props.theme.colors.mercuryBlue};
        height: 10px;
        width: 10px;
        display: inline;
        margin-right: 2px;
      }
    }
    ${maxWidth.medium`
      padding-left: 16px;
      padding-right: 16px;
      max-width: 220px;
    `}
  }
  
  .mp-breadcrumbs-blue-to-white {
    position: absolute;
    width: 100%;
    .breadcrumbs__item {
      color: ${props => props.theme.colors.alto};
    }
    .breadcrumbs-row__back-nav {
      z-index: 1;
    }
  }
  
  .edit-menu__options-item {
    position: relative;
    &__messages {
      width: 10px;
      height: 10px;
      -webkit-border-radius: 25px;
      -moz-border-radius: 25px;
      border-radius: 40px;
      background: red;
      position: absolute;
      left: 25px;
      bottom: 5px;
      &--hide {
        display: none;
      }
  
      ${maxWidth.small`
        left: 0;
      `}
    }
  }
}

.mp-breadcrumbs-blue-to-white {
  .breadcrumbs__item {
    color: ${props => props.theme.colors.alto};
  }
  .breadcrumbs-row__back-nav {
    z-index: 1;
  }
}

.edit-menu__options-item {
  position: relative;
  &__messages {
    width: 10px;
    height: 10px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 40px;
    background: red;
    position: absolute;
    left: 85px;
    bottom: 6px;
    &--hide {
      display: none;
    }

    ${maxWidth.small`
      left: 0;
    `}
  }
}
`
